import { useMemo } from "react";

import { ClubSection } from "@/components/ClubSection";
import { CompeteSection } from "@/components/CompeteSection";
import { Footer } from "@/components/Footer";
import { Hero } from "@/components/Hero";
import { JoinSection } from "@/components/JoinSection";
import { Marquee } from "@/components/Marquee";
import { Masthead } from "@/components/Masthead";
import { MeetingsSection } from "@/components/MeetingsSection";
import { NextQueue } from "@/components/NextQueue";
import { ProjectsSection } from "@/components/ProjectsSection";
import { RosterSection } from "@/components/RosterSection";
import { api } from "@/lib/api";
import { SECTIONS } from "@/lib/sections";
import { useActiveSection } from "@/lib/useActiveSection";
import { useApi } from "@/lib/useApi";
import { useHashScroll } from "@/lib/useHashScroll";

/** The club's own shouting, carried over from the previous site. */
const PHRASES = [
  "Stack. Clear. Compete.",
  "No misdrops. No mercy.",
  "T-spin. Quad. Skim.",
  "Big downstack :D",
  "Perfect clear loops.",
  "GO DOWN!!!",
  "Build surge. Spirit bomb.",
];

export function Home() {
  const sectionIds = useMemo(() => SECTIONS.map((section) => section.id), []);
  const activeId = useActiveSection(sectionIds);
  useHashScroll();

  const club = useApi((signal) => api.club(signal));
  const roster = useApi((signal) => api.roster(signal));
  const events = useApi((signal) => api.events(3, signal));

  return (
    <>
      <NextQueue activeId={activeId} />

      <div className="xl:pl-[var(--rail-width)]">
        <Masthead activeId={activeId} club={club.data} />

        <main>
          <Hero club={club.data} />
          <Marquee phrases={PHRASES} />
          <ClubSection club={club.data} />
          <MeetingsSection
            club={club.data}
            events={events.data?.events ?? []}
            loading={events.loading}
          />
          <RosterSection
            players={roster.data?.players ?? []}
            meta={roster.data?.meta ?? null}
            loading={roster.loading}
            error={roster.error}
          />
          <CompeteSection club={club.data} totals={roster.data?.totals ?? null} />
          <ProjectsSection />
          <JoinSection club={club.data} />
        </main>

        <Footer club={club.data} />
      </div>
    </>
  );
}
